<template>
  <v-card id="project-summary__content">
    <v-row>
      <v-col cols="10">
        <demand-fulfillment-overview />
      </v-col>
      <v-col cols="2">
        <selected-regions />
      </v-col>
    </v-row>
  </v-card>
  
</template>

<script>
import DemandFulfillmentOverview from './DemandFulfillmentOverview.vue'
import SelectedRegions from './SelectedRegions.vue'

export default {
  components: { DemandFulfillmentOverview, SelectedRegions },
}
</script>
